import { calculateBloodPressure } from './blood-pressure';
import { calculateGlucose } from './glucose';
import { compose } from './interpreter';
import { calculateEarlyWarningScores } from './news';
export { getMetadata, isValidReading } from './metadata';
export const calculateDerivedMeasures = compose([calculateBloodPressure, calculateEarlyWarningScores, calculateGlucose]);
export { getAggregatedRanges } from './aggregate';
//# sourceMappingURL=index.js.map